import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";

// Api
import {
  downloadRouteAnalysisPdfReportFn,
  getRouteSummaryFn,
} from "../../apis/mavin-tools/RouteAnalysisToolAPI";

// Utils and Constants
import { getErrorMessage } from "../../utils/util";
import { RouteAnalysis } from "../../constants/action-constants/mavin-tools/RouteAnalysisActionConstants";
import { ReportConstants } from "../../constants/GeneralConstants";
import { saveFile } from "../../common-utils/file-utils/FileUtils";

function* getRouteSummary(action) {
  const { stretchId, targetGroupId, startTS, duration } = action.payload;
  try {
    const routeInfo = yield getRouteSummaryFn(
      stretchId,
      targetGroupId,
      startTS,
      duration
    );

    yield put({
      type: RouteAnalysis.GET_ROUTE_SUMMARY_SUCCESS,
      payload: { routeInfo: routeInfo },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);

    yield put({
      type: RouteAnalysis.GET_ROUTE_SUMMARY_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export function* downloadRouteAnalysisPdfReport(action) {
  try {
    const {
      cityName,
      selectedRouteName,
      stretchId,
      targetGroupId,
      startTS,
      durationInDays,
      mapCenter,
      mapZoom,
    } = action.payload;

    const data = yield downloadRouteAnalysisPdfReportFn(
      cityName,
      stretchId,
      targetGroupId,
      startTS,
      durationInDays,
      mapCenter,
      mapZoom
    );

    // file name
    const pdfFileName = `${selectedRouteName}_${ReportConstants.ROUTE_ANALYSIS_PDF_REPORT}`;

    // save file
    saveFile(pdfFileName, data);

    yield put({
      type: RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_SUCCESS,
    });
  } catch (err) {
    const errMsg = getErrorMessage(err);
    yield put({
      type: RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_FAILURE,
      payload: err,
    });
    toast.error(errMsg);
  }
}

export default function* root() {
  yield all([
    takeLatest(RouteAnalysis.GET_ROUTE_SUMMARY, getRouteSummary),
    takeLatest(
      RouteAnalysis.DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT,
      downloadRouteAnalysisPdfReport
    ),
  ]);
}
